import { motion } from "framer-motion";

export default function KineticTitle({ lines, accentIndex = -1, className = "", delay = 0 }) {
  return (
    <h1 className={className} data-testid="kinetic-title">
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${i === accentIndex ? "italic text-gold-bright" : ""}`}
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: delay + i * 0.13, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}
